<template>
  <v-app>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "application",
  watch: {
    $route(to, from) {
      document.title = to.meta.title || "ACS Accelery GmbH";
    }
  }
};
</script>
<style>
@import url("assets/style.css");
</style>